import { signal } from "@preact/signals-react";

export const isDroppableSignal = signal(false);